var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.3334 64.4584H14.1667C8.30175 64.4584 3.54175 59.6984 3.54175 53.8334V5.66675C3.54175 4.50508 4.50508 3.54175 5.66675 3.54175C6.82841 3.54175 7.79175 4.50508 7.79175 5.66675V53.8334C7.79175 57.3468 10.6534 60.2084 14.1667 60.2084H62.3334C63.4951 60.2084 64.4584 61.1718 64.4584 62.3334C64.4584 63.4951 63.4951 64.4584 62.3334 64.4584Z",
    fill: "#5F5F5F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1662 50.2916C13.6846 50.2916 13.1746 50.1216 12.7779 49.7816C11.8996 49.0166 11.7862 47.6849 12.5512 46.7783L25.5562 31.5916C26.9729 29.9482 29.0129 28.9566 31.1662 28.8716C33.3196 28.8149 35.4446 29.6082 36.9746 31.1382L39.6662 33.8299C40.3746 34.5382 41.3096 34.8782 42.3012 34.8782C43.2929 34.8499 44.1996 34.3966 44.8512 33.6316L57.8562 18.4449C58.6212 17.5666 59.9529 17.4532 60.8596 18.2182C61.7379 18.9832 61.8512 20.3149 61.0862 21.2215L48.0812 36.4083C46.6646 38.0516 44.6246 39.0432 42.4712 39.1282C40.3179 39.1849 38.1929 38.3916 36.6629 36.8616L33.9996 34.1699C33.2912 33.4616 32.3562 33.0932 31.3646 33.1216C30.3729 33.1499 29.4662 33.6033 28.8146 34.3683L15.8096 49.5549C15.3562 50.0365 14.7612 50.2916 14.1662 50.2916Z",
    fill: "#5F5F5F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiagram);
export default __webpack_public_path__ + "static/media/diagram.a940f501e16af57394aa4f0bed42644a.svg";
export { ForwardRef as ReactComponent };